/**
 * Huraga theme utilities - minimal version of FOSSBilling utilities
 * Only includes functionality actually used by the Huraga theme
 */

import Swal from "sweetalert2";

globalThis.FOSSBilling = {
  message: (message, type = "info") => {
    const titles = {
      error: "Error!",
      warning: "Warning!",
      success: "Success!",
      info: "Info",
    };
    const icons = {
      error: "error",
      warning: "warning",
      success: "success",
      info: "info",
    };

    Swal.fire({
      icon: icons[type] || "info",
      title: titles[type] || "Info",
      text: message,
      confirmButtonText: "OK",
    });
  }
};